(function () {
  function init(section) {
    const titleElement = section.querySelector('.activities-collection__title');
    const descElement = section.querySelector('.activities-collection__decription');

    const activityCache = new Map();
    section.querySelectorAll('template.activities-collection__template').forEach(function (tpl) {
      activityCache.set(tpl.dataset.activityHandle, {
        tagline: tpl.content.querySelector('[data-tagline]'),
        description: tpl.content.querySelector('[data-description]'),
      });
    });

    const items = section.querySelectorAll('[data-assignment-activity]');
    const buttons = section.querySelectorAll('.activities-collection__activity');

    function applyFilter(handle, pushState) {
      const activity = activityCache.get(handle);
      if (activity) {
        if (activity.tagline && titleElement) titleElement.innerHTML = activity.tagline.innerHTML.trim();
        if (activity.description && descElement) descElement.innerHTML = activity.description.innerHTML.trim();
      }

      const isAll = handle === 'all';
      items.forEach(function (item) {
        item.hidden = !isAll && item.dataset.assignmentActivity !== handle;
        const badges = item.querySelector('.product-card__badges');
        if (badges) badges.hidden = isAll;
      });

      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.activityHandle === handle);
      });

      if (pushState) {
        const url = new URL(window.location.href);
        if (handle === 'all') {
          url.searchParams.delete('activity');
        } else {
          url.searchParams.set('activity', handle);
        }
        window.history.pushState({}, '', url);
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.dataset.activityHandle, true);
      });
    });

    const initialHandle = new URL(window.location.href).searchParams.get('activity') || 'all';
    applyFilter(initialHandle, false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-section-type="page-activities"]').forEach(function (section) {
      if (!section.dataset.pageActivitiesInit) {
        section.dataset.pageActivitiesInit = '1';
        init(section);
      }
    });
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
